<template>
    <div class="body_main">

        <div class="body_bd flex_t_between">
            <div class="person_left">
                <div :class="activePersonTab === 'baseInfo' ? 'left_li left_li_1 left_li_act':'left_li left_li_1'"
                     @click="choosePersonTab('baseInfo')">
                    <div class="trangle2" v-if="activePersonTab === 'baseInfo'"></div>
                    <span>基本信息</span>
                </div>
<!--                <div :class="activePersonTab === 'feesSetting' ? 'left_li left_li_2 left_li_act':'left_li left_li_2'"-->
<!--                     @click="choosePersonTab('feesSetting')">-->
<!--                    <div class="trangle2" v-if="activePersonTab === 'feesSetting'"></div>-->
<!--                    <span>门诊诊费</span>-->
<!--                </div>-->

                <div :class="activePersonTab === 'treatFeeRateSetting' ? 'left_li left_li_2 left_li_act':'left_li left_li_2'"
                     @click="choosePersonTab('treatFeeRateSetting')">
                    <div class="trangle2" v-if="activePersonTab === 'treatFeeRateSetting'"></div>
                    <span>诊后病程管理设置</span>
                </div>
<!--                <div :class="activePersonTab === 'newRule' ? 'left_li left_li_3 left_li_act':'left_li left_li_3'"
                     @click="choosePersonTab('newRule')">
                    <div class="trangle2" v-if="activePersonTab === 'newRule'"></div>
                    <span>新标转换</span>
                </div>-->
                <div :class="activePersonTab === 'editPassword' ? 'left_li left_li_3 left_li_act':'left_li left_li_3'"
                     @click="choosePersonTab('editPassword')">
                    <div class="trangle2" v-if="activePersonTab === 'editPassword'"></div>
                    <span>修改密码</span>
                </div>
            </div>
            <div class="person_line"></div>
            <div class="person_right">
                <!-- 基本信息-->
                <div class="person_base_info" v-if="activePersonTab === 'baseInfo'">
                    <el-form class="step_floor_con" ref="form" :model="doctorInfo" label-width="100px">
                        <el-row class="person_info_width" :gutter="20">
                            <el-col :span="24">
                                <el-form-item label="门诊头像">
                                    <el-upload
                                        class="avatar-uploader"
                                        :action="uploadFileURL"
                                        :headers="uploadHeaders"
                                        :show-file-list="false"
                                        :on-success="handleAvatarSuccess"
                                        :before-upload="beforeAvatarUpload"
                                    >
                                        <img v-if="imageUrl" :src="imageUrl" class="avatar"/>
                                        <el-icon v-else class="avatar-uploader-icon">
                                            <Plus/>
                                        </el-icon>
                                    </el-upload>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row class="person_info_width" :gutter="20">
                            <el-col :span="24">
                                <el-form-item label="姓名">
                                    <el-input v-model="doctorInfo.name" placeholder="姓名"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row class="person_info_width" :gutter="20">
                            <el-col :span="24">
                                <el-form-item label="性别">
                                    <el-radio-group v-model="doctorInfo.sex">
                                        <el-radio label="0">男</el-radio>
                                        <el-radio label="1">女</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row class="person_info_width" :gutter="20">
                            <el-col :span="24">
                                <el-form-item label="手机号">
                                    <el-input v-model="doctorInfo.phoneNumber" placeholder="手机号"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row class="person_info_width" :gutter="20">
                            <el-col :span="24">
                                <el-form-item label="邮箱">
                                    <el-input v-model="doctorInfo.email" placeholder="邮箱"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row class="person_info_width" :gutter="20">
                            <el-col :span="24">
                                <el-form-item label="职称">
                                    <el-input v-model="doctorInfo.workTitle" placeholder="职称" readonly disabled></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="24">
                                <el-form-item label="门诊科室">
                                    <el-select v-model="doctorInfo.odIds" multiple placeholder="请选择门诊科室">
                                        <el-option   v-for="item in outpatientList"
                                                     :key="item.odId"
                                                     :label="item.odName"
                                                     :value="item.odId">
                                        </el-option>

                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="24">
                                <el-form-item label="擅长">
                                    <el-input :rows="4" type="textarea" v-model="doctorInfo.goodAt"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="24">
                                <el-form-item label="简介">
                                    <el-input :rows="4" type="textarea" v-model="doctorInfo.introduction"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col class="person_base_btns" :span="24">
                                <el-button class="mrr10" type="info">取消</el-button>
                                <el-button class="mrl10" type="primary" @click="updateDoctorBaseInfo()">保存</el-button>
                            </el-col>
                        </el-row>
                    </el-form>
                </div>
                <!-- 诊费设置-->
                <div class="person_base_info" v-if="activePersonTab === 'feesSetting'">
                    <el-form class="feesSetting_width" ref="form" label-width="100px">
                        <el-row :gutter="20">
                            <el-col :span="6">
                                <el-radio v-model="doctorInfo.clinicDocPriceWay" label="0">自定义</el-radio>
                            </el-col>
                            <el-col :span="18">
                                <el-input placeholder="自定义" v-model="doctorInfo.clinicDocPrice">
                                    <template #append>元</template>
                                </el-input>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="6">
                                <el-radio v-model="doctorInfo.clinicDocPriceWay" label="1">百分比</el-radio>
                            </el-col>
                            <el-col :span="18">
                                <el-input placeholder="百分比" v-model="doctorInfo.clinicDocPriceRate">
                                    <template #append>%</template>
                                </el-input>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col class="person_base_btns" :span="24">
                                <el-button class="mrr10" type="info" @click="cancelSaveDocPriceInfo()">取消</el-button>
                                <el-button class="mrl10" type="primary" @click="saveDocPriceInfoFn()">保存</el-button>
                            </el-col>
                        </el-row>
                    </el-form>
                </div>
                <!-- 诊后病程管理费用设置-->
                <div class="person_base_info" v-if="activePersonTab === 'treatFeeRateSetting'">
                    <el-form class="feesSetting_width" ref="form" label-width="100px">
                        <el-row :gutter="20">
                            <el-col :span="24">
                                <span v-if="hasTreatFeeMaxRate">最大不能超过 {{ doctorInfo.treatFeeMaxRate }}%，将根据药费按百分比自动换算并按规则取整</span>
                                <span v-else>建议设置 0% - 50%，将根据药费按百分比自动换算并按规则取整</span>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="24">
                                <el-input placeholder="百分比" v-model="doctorInfo.treatFeeRate">
                                    <template #append>%</template>
                                </el-input>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col class="person_base_btns" :span="24">
                                <el-button class="mrr10" type="info" @click="cancelSaveTreatFeeRateSettingInfo()">取消</el-button>
                                <el-button class="mrl10" type="primary" @click="saveDocTreatFeeRateSettingInfoFn()">保存</el-button>
                            </el-col>
                        </el-row>
                    </el-form>
                </div>
                <!-- 新标转换-->
                <div class="person_base_info" v-if="activePersonTab === 'newRule'">
                    <!-- 颗粒的新标开启-->
                    <el-form class="feesSetting_width" ref="form" label-width="100px">
                        <el-row :gutter="20">
                            <div class="med_con_div flex_c_left">
                                <div class="med_con_tent flex_c_left flex_c_wrap">
                                    <div class="med_con_tit flex_c_left">新标剂量转换设置</div>
                                    <div class="med_con_info flex_c_left">新标药材系统将自动转换为新标剂量</div>
                                </div>
                                <div class="med_con_btn flex_c_left">
                                    <el-switch v-model="newRuleOpen" inline-prompt active-text="开" inactive-text="关"></el-switch>
                                </div>
                            </div>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col class="person_base_left" :span="24">
                                <el-button class="mrr10" type="info" @click="cancelSaveSwitchNewRule()">取消</el-button>
                                <el-button class="mrl10" type="primary" @click="saveDocNewRuleFn()">保存</el-button>
                            </el-col>
                        </el-row>
                    </el-form>
                </div>
                <!-- 修改密码-->
                <div class="person_base_info" v-if="activePersonTab === 'editPassword'">
                    <el-form class="person_info_width step_floor_con" ref="form" label-width="100px">
                        <el-row :gutter="20">
                            <el-col :span="24">
                                <el-form-item label="旧密码">
                                    <el-input type="password" show-password v-model="oldPassword"
                                              placeholder="请输入账号的旧密码"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="24">
                                <el-form-item label="新密码">
                                    <el-input type="password" show-password v-model="newPassword"
                                              placeholder="请输入修改后的新密码"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="24">
                                <el-form-item label="确认密码">
                                    <el-input type="password" show-password v-model="confirmPassword"
                                              placeholder="请再次输入修改后的新密码"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col class="person_base_btns" :span="24">
                                <el-button class="mrr10" type="info">取消</el-button>
                                <el-button class="mrl10" type="primary" @click="sureEditPassword()">确认</el-button>
                            </el-col>
                        </el-row>
                    </el-form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Personal from "@/assets/scripts/personal/index.js";

export default Personal;
</script>

<style scoped>
@import "@/assets/styles/style.scss";
</style>